import * as React from 'react';
import { useState, useEffect } from "react";
import axios from "../../components/axios";
import TreeView from '@mui/lab/TreeView';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import TreeItem from '@mui/lab/TreeItem';
import MainCard from '../components/MainCard';
import GenericContent from '../components/GenericContent';
import LeafContent from '../components/LeafContent';
import DialogAppOnly from '../components/DialogAppOnly';
import DialogBLApp from '../components/DialogBLApp';
import DialogPrism from '../components/DialogPrism';
import { Box, Card, CardContent } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux'


const StableBuildTreeView = () => {
  const customization = useSelector((state) => state.customization);
  const [stableBuild, setStableBuild] = useState({});
  const [newBuild, setNewBuild] = useState({});
  const [open, setOpen] = useState(false);
  const [openBLDialog, setOpenBLDialog] = useState(false);
  const [openPrismDialog, setOpenPrismDialog] = useState(false);
  const [dialogTitle, setDialogTitle] = useState('');
  const [app, setApp] = useState('');
  const [version, setVersion] = useState('');
  const [blapp, setBLApp] = useState('');
  const [preApp, setPreApp] = useState('');
  const [preVersion, setPreVersion] = useState('');
  const [versionMCB, setVersionMCB] = useState('');
  const [f103, setF103] = useState('');
  const [l485, setL485] = useState('');
  const [preVersionMCB, setPreVersionMCB] = useState('');
  const [preF103, setPreF103] = useState('');
  const [preL485, setPreL485] = useState('');
  const navigate = useNavigate();

  const getStableBuilds = async () => {
    try {
      const response = await axios.post("/peloton/v1/automation/stable-builds", null, { withCredentials: true});
      if (response.data.message === "success"){
        setStableBuild(response.data.stable_version);
        setNewBuild(response.data.new_version);
      }
    } catch (error) {
      if (error.response.status !== null){
        if (error.response.status === 401){
          alert(error.response.data.message);
          navigate("/");
        }else{
          console.log('error.response.status: ', error.response.status);
          console.log('error.response.message: ', error.response.data.message);
        }
      }else{
        console.log(error);
      }
    }
  };

  useEffect(() => {
        getStableBuilds();
        // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

function GenericTreeItem(props) {
  return <TreeItem ContentComponent={GenericContent} {...props} />;
};

function LeafTreeItem(props) {
  return <TreeItem ContentComponent={LeafContent} {...props} />;
};


const handleTreeItemClick = (node) => {
  if (node.link !== undefined){
    if (node.link === '' || node.link === 'NA'){
      alert('No image information');
    }else{
      window.open(node.link, "_blank");
    }
  }
};

const handleTreeGenericItemClick = (node) => {
  if (node.label === 'Affernet' || node.label === 'Titan' || node.label === 'Prism' || node.label === 'Caesar' || node.label === 'swallow' ){
    setDialogTitle(node.label);
    switch (node.label) {
      case 'Prism': {
        let temp_stable_sc = extractValueObj(node, 'Stable FW:SC');
        let temp_version = extractValue(temp_stable_sc, 'Version:');
        setVersion(temp_version.label);
        let temp_app = extractValue(temp_stable_sc, 'APP:');
        setApp(temp_app.link);
        let temp_blapp = extractValue(temp_stable_sc, 'BLAPP:');
        setBLApp(temp_blapp.link);

        let temp_stable_mcb = extractValueObj(node, 'Stable FW:MCB');
        let temp_version_mcb = extractValue(temp_stable_mcb, 'Version:');
        setVersionMCB(temp_version_mcb.label);
        let temp_f103_mcb = extractValue(temp_stable_mcb, 'F103:');
        setF103(temp_f103_mcb.link);
        let temp_l485_mcb = extractValue(temp_stable_mcb, 'L485:');
        setL485(temp_l485_mcb.link);

        let temp_pre_sc = extractValueObj(node, 'Previous Stable FW:SC');
        let temp_pre_sc_version = extractValue(temp_pre_sc, 'Version:');
        setPreVersion(temp_pre_sc_version.label);
        let temp_pre_blapp = extractValue(temp_pre_sc, 'BLAPP:');
        setPreApp(temp_pre_blapp.link);

        let temp_pre_mcb = extractValueObj(node, 'Previous Stable FW:MCB');
        let temp_pre_version_mcb = extractValue(temp_pre_mcb, 'Version:');
        setPreVersionMCB(temp_pre_version_mcb.label);
        let temp_pre_f103_mcb = extractValue(temp_pre_mcb, 'F103:');
        setPreF103(temp_pre_f103_mcb.link);
        let temp_pre_l485_mcb = extractValue(temp_pre_mcb, 'L485:');
        setPreL485(temp_pre_l485_mcb.link);

        setOpenPrismDialog(true);
      }
      break

      case 'Titan': {
        let temp_stable_fw = extractValueObj(node, 'Stable FW');
        let temp_version = extractValue(temp_stable_fw, 'Version:');
        setVersion(temp_version.label);
        let temp_app = extractValue(temp_stable_fw, 'APP:');
        setApp(temp_app.link);
        let temp_blapp = extractValue(temp_stable_fw, 'BLAPP:');
        setBLApp(temp_blapp.link);

        let temp_pre_fw = extractValueObj(node, 'Previous Stable FW');
        let temp_pre_version = extractValue(temp_pre_fw, 'Version:');
        setPreVersion(temp_pre_version.label);
        let temp_pre_blapp = extractValue(temp_pre_fw, 'BLAPP:');
        setPreApp(temp_pre_blapp.link);

        setOpenBLDialog(true);
      }
      break

      case 'Caesar': {
        let temp_stable_fw = extractValueObj(node, 'Stable FW');
        let temp_version = extractValue(temp_stable_fw, 'Version:');
        setVersion(temp_version.label);
        let temp_app = extractValue(temp_stable_fw, 'APP:');
        setApp(temp_app.link);
        let temp_blapp = extractValue(temp_stable_fw, 'BLAPP:');
        setBLApp(temp_blapp.link);

        let temp_pre_fw = extractValueObj(node, 'Previous Stable FW');
        let temp_pre_version = extractValue(temp_pre_fw, 'Version:');
        setPreVersion(temp_pre_version.label);
        let temp_pre_blapp = extractValue(temp_pre_fw, 'BLAPP:');
        setPreApp(temp_pre_blapp.link);

        setOpenBLDialog(true);
      }
      break

      default: {
        let temp_version = extractValue(node, 'Version:');
        setVersion(temp_version.label);
        let temp_url = extractValue(node, 'URL:');
        setApp(temp_url.link);

        setOpen(true);
      }
      break

    }
  }
};

  const handleUpdateData = async () => {
    var input_data = JSON.stringify({ project: dialogTitle, data: { app: app, blapp: blapp, previous_version: preVersion,
      previous_blapp: preApp, version: version, mcb_version: versionMCB, mcb_f103: f103, mcb_l485: l485, previous_mcb_version: preVersionMCB,
      previous_mcb_f103: preF103, previous_mcb_l485: preL485}});
    axios.post('/peloton/v1/automation/update-stable-builds', input_data, {withCredentials: true})
    .then(response => {
      if (response.data.message === "success") {
        getStableBuilds();
        navigate("/stable-builds");
      }else{
        alert(response.data.message);
      }
    }).catch(function(err){
      if (!err.response){
        alert(err);
      }else{
        if (err.response.status === 401){
          alert(err.response.data.message);
          navigate("/");
        }else{
          console.log('error.response.status: ', err.response.status);
          console.log('error.response.status: ', err.response.data.message);
          alert(err.response.data.message);
        }
      }
    })
  };

  const handleClose = () => {
    handleUpdateData();
    setOpen(false);
  };

  const handleBLDialogClose = () => {
    handleUpdateData();
    setOpenBLDialog(false);
  };

  const handlePrismDialogClose = () => {
    handleUpdateData();
    setOpenPrismDialog(false);
  };

  const extractValue = (input, key) => {
    let temp = input.children.filter(o => o.label === key);
    return temp[0].children[0]
  };

  const extractValueObj = (input, key) => {
    let temp = input.children.filter(o => o.label === key);
    return temp[0];
  };

  const renderStableTree = (nodes) => {
    switch (nodes.header) {
      case 'leaf':
        return (<LeafTreeItem key={nodes.label} nodeId={nodes.label ? nodes.label : "defaultNodeId"} label={nodes.label} onClick={() => handleTreeItemClick(nodes)}>
                  {Array.isArray(nodes.children)
                    ? nodes.children.map((node) => renderStableTree(node))
                    : null}
                </LeafTreeItem>);

      default:
        return (<GenericTreeItem key={nodes.label} nodeId={nodes.label ? nodes.label : "defaultNodeId"} label={nodes.label} onClick={() => handleTreeGenericItemClick(nodes)}  sx={{ fontFamily: '"Roboto", "sans-serif"' }}>
                  {Array.isArray(nodes.children)
                    ? nodes.children.map((node) => renderStableTree(node))
                    : null}
                </GenericTreeItem>);
    }
  };

  const renderNewTree = (nodes) => {
    switch (nodes.header) {
      case 'leaf':
        return (<LeafTreeItem key={nodes.label} nodeId={nodes.label ? nodes.label : "defaultNodeId"} label={nodes.label} onClick={() => handleTreeItemClick(nodes)}>
                  {Array.isArray(nodes.children)
                    ? nodes.children.map((node) => renderNewTree(node))
                    : null}
                </LeafTreeItem>);

      default:
        return (<GenericTreeItem key={nodes.label} nodeId={nodes.label ? nodes.label : "defaultNodeId"} label={nodes.label}  sx={{ fontFamily: '"Roboto", "sans-serif"' }}>
                  {Array.isArray(nodes.children)
                    ? nodes.children.map((node) => renderNewTree(node))
                    : null}
                </GenericTreeItem>);
    }
  };

  return (
    <MainCard title={'Stable Builds'}>
    <Card variant="outlined" sx={{ bgcolor: "white" }}>
      <CardContent>
      <Box sx={{ fontSize: '20px', color:"#406599", pb:'15px'}}>
          Stable Builds
      </Box>
      <TreeView
        aria-label="rich object"
        defaultCollapseIcon={<ExpandMoreIcon />}
        defaultExpanded={['Stable builds','Version:','URL:','APP:','BLAPP:','F103:','L485:']}
        defaultExpandIcon={<ChevronRightIcon />}
        sx={{ overflowY: 'auto',fontFamily: '"Roboto", "sans-serif"' }}
      >
        {renderStableTree(stableBuild)}
      </TreeView>
      </CardContent>
      </Card>
      <Card variant="outlined" sx={{ bgcolor: "white" }}>
      <CardContent>
      <Box sx={{ fontSize: '20px', color:"#406599", pb:'15px'}}>
          New Version
      </Box>
      <TreeView
        aria-label="rich object"
        defaultCollapseIcon={<ExpandMoreIcon />}
        defaultExpanded={['New Versions','Version:','URL:','APP:','BLAPP:','F103:','L485:']}
        defaultExpandIcon={<ChevronRightIcon />}
        sx={{ overflowY: 'auto',fontFamily: '"Roboto", "sans-serif"' }}
      >
        {renderNewTree(newBuild)}
      </TreeView>
      </CardContent>
      </Card>
      {customization.login && (<DialogAppOnly open={open} dialogTitle={dialogTitle}
        app={app} setApp={setApp}
        version={version} setVersion={setVersion}
        handleClose={handleClose}/>)}
      {customization.login && (<DialogBLApp open={openBLDialog} dialogTitle={dialogTitle}
        app={app} setApp={setApp}
        blapp={blapp} setBLApp={setBLApp}
        version={version} setVersion={setVersion}
        preApp={preApp} setPreApp={setPreApp}
        preVersion={preVersion} setPreVersion={setPreVersion}
        handleClose={handleBLDialogClose}/>)}
      {customization.login && (<DialogPrism open={openPrismDialog} dialogTitle={dialogTitle}
        scApp={app} setSCApp={setApp}
        scBLApp={blapp} setSCBLApp={setBLApp}
        scVersion={version} setSCVersion={setVersion}
        mcbVersion={versionMCB} setMcbVersion={setVersionMCB}
        mcbF103={f103} setMcbF103={setF103}
        mcbL485={l485} setMcbL485={setL485}
        preSCVersion={preVersion} setPreSCVersion={setPreVersion}
        preSCBLApp={preApp} setPreSCBLApp={setPreApp}
        preMcbVersion={preVersionMCB} setPreMcbVersion={setPreVersionMCB}
        preMcbF103={preF103} setPreMcbF103={setPreF103}
        preMcbL485={preL485} setPreMcbL485={setPreL485}
        handleClose={handlePrismDialogClose}/>)}
    </MainCard>
  );
};

export default StableBuildTreeView;

